module.exports = __webpack_public_path__ + "fonts/righthand-extrabolditalic-personal.03684596.ttf";